exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#failure[data-v-7eeb5200]{height:40em;position:relative}.image[data-v-7eeb5200]{height:500;width:500;padding-bottom:10vh}#failure div[data-v-7eeb5200]{margin:0;position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%,-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7eeb5200","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Failure.vue
// module id = 528
// module chunks = 0